// Muestras1.jsx
import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Box,
  Typography,
  Grid,
  Checkbox,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
} from "@mui/material";

import { getUserById } from "../../api/User/userApi";
import { jwtDecode } from "jwt-decode";

import { parseMuestraDate } from "../../utils/dateUtils";
import { formatEstadoLabel } from "./Drawer/muestraEstadoHelpers";
import { useTranslation } from "react-i18next";

import { useTheme, alpha } from "@mui/material/styles";
import { SidebarContext } from "../Sidebar/SidebarProvider";

import {
  getAllMuestras,
  getMuestrasEstado,
  getTallas,
  getColoresMuestras,
  getProveedores,
  getVistaMuestrasDesigners,
  getMarcas,
  getEscandalloGrupos,
  updateMuestra,
  getEscandalloSubgruposMuestras,
  getEscandallosByMuestraId,
  getMuestraById,
  getMuestrasTipo,
  getMuestrasTemporadas,
} from "../../api/Muestras/muestraApi";

import MuestraCard from "./MuestraCard";
import DrawerMuestra from "./DrawerMuestra";

import DrawerMuestraV2 from "./Drawer/DrawerMuestraV2";
import MuestrasExportExcelDialog from "./MuestrasExportExcelDialog";
import MuestrasExportPdfDialog from "./MuestrasExportPdfDialog";

const Muestras1 = () => {
  const theme = useTheme();
  const { contentMargin } = useContext(SidebarContext);

  const { t } = useTranslation();

  const [muestras, setMuestras] = useState([]);
  const [designers, setDesigners] = useState([]);

  const [selectedMuestra, setSelectedMuestra] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);

  // FILTROS
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDesigners, setSelectedDesigners] = useState([]);
  const [selectedMarcas, setSelectedMarcas] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState([]);
  const [selectedTallas, setSelectedTallas] = useState([]);
  const [selectedColores, setSelectedColores] = useState([]);
  const [selectedProveedores, setSelectedProveedores] = useState([]);
  const [showPendingArrival, setShowPendingArrival] = useState(false);

  const [estados, setEstados] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [colores, setColores] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [marcas, setMarcas] = useState([]);

  const [escandalloGrupos, setEscandalloGrupos] = useState([]);
  const [tiposMuestra, setTiposMuestra] = useState([]);
  const [escandalloSubgrupos, setEscandalloSubgrupos] = useState([]);

  const [selectedTemporadas, setSelectedTemporadas] = useState([]);
  const [temporadasData, setTemporadasData] = useState([]);
  const temporadasUnicas = [
    ...new Set((temporadasData || []).map((t) => t.TEMPORADA || "NO SEASON")),
  ];

  // Scroll infinito
  const [page, setPage] = useState(1);
  const itemsPerPage = 20;
  const loaderRef = useRef(null);
  const containerRef = useRef(null);

  const [refreshKey, setRefreshKey] = useState(0);

  // CHINA

  const [userData, setUserData] = useState(null);

  const token = localStorage.getItem("token");
  const decoded = token ? jwtDecode(token) : null;
  const userCanCreateSample = decoded?.PermisoCreateSample === true;

  // LOAD DATA

  useEffect(() => {
    const load = async () => {
      if (!token || !decoded) return;

      try {
        const user = await getUserById(decoded.userId);
        setUserData(user);
        await loadData(user);
      } catch (err) {
        console.error("Error loading user:", err);
      }
    };

    load();
  }, []);

  const loadData = async (user) => {
    try {
      const [
        muestrasData,
        estadosData,
        tallasData,
        coloresData,
        proveedoresData,
        designersData,
        marcasData,
        escandalloGruposData,
        tiposMuestraData,
        temporadasDataRaw,
      ] = await Promise.all([
        getAllMuestras(),
        getMuestrasEstado(),
        getTallas(),
        getColoresMuestras(),
        getProveedores(),
        getVistaMuestrasDesigners(),
        getMarcas(),
        getEscandalloGrupos(),
        getMuestrasTipo(),
        getMuestrasTemporadas(),
      ]);
      setTiposMuestra(tiposMuestraData);
      setEstados(estadosData);
      setTallas(tallasData);
      setColores(coloresData);
      setProveedores(proveedoresData);
      setMarcas(marcasData);
      setDesigners([...new Set(designersData.map((d) => d.username))]);

      setEscandalloGrupos(escandalloGruposData);
      setTemporadasData(temporadasDataRaw);

      let enriched = muestrasData.map((m) => {
        const estado = estadosData.find((e) => e.ID_ESTADO === m.ID_ESTADO);
        const talla = tallasData.find((t) => t.ID_TALLA === m.ID_TALLA_BASE);
        const color = coloresData.find((c) => c.ID_COLOR === m.ID_COLOR_BASE);
        const proveedor = proveedoresData.find(
          (p) => String(p.CODPROV) === String(m.PROVEEDOR),
        );
        const designer = designersData.find(
          (d) => d.ID_MUESTRA === m.ID_MUESTRA,
        );
        const marca = marcasData.find(
          (ma) => String(ma.ID_MARCA) === String(m.ID_Marca),
        );
        const temporada = temporadasDataRaw.find(
          (t) => t.ID_MUESTRA === m.ID_MUESTRA,
        );

        return {
          ...m,
          id: m.ID_MUESTRA,
          ESTADO_NOMBRE: estado?.ESTADO || "Desconocido",
          TALLA_NOMBRE: talla?.TALLA || "Desconocida",
          COLOR_PANTONE: color?.PANTONE || "Desconocido",
          COLOR_HEX: color?.HEX || "#ccc",
          NOMBRE_PROVEEDOR: proveedor?.N_PROVEEDOR || "Desconocido",
          DISENADOR: designer?.username || "Desconocido",
          NOMBRE_CLIENTE: marca?.MARCA || "Desconocido",

          // FECHAS (FIX DEFINITIVO)
          FECHA_PREVISTA: parseMuestraDate(m.FECHA_PREVISTA),
          FECHA_GET_SUPPLIER: parseMuestraDate(m.FECHA_GET_SUPPLIER),
          FECHA_PETICION: parseMuestraDate(m.FECHA_PETICION),
          FECHA_ENVIO: parseMuestraDate(m.FECHA_ENVIO),
          FECHA_RECEPCION: parseMuestraDate(m.FECHA_RECEPCION),
          FECHA_PREVISTA_FABRICA: parseMuestraDate(m.FECHA_PREVISTA_FABRICA),
          TEMPORADA: temporada?.TEMPORADA || "NO SEASON",
        };
      });

      // FILTRO POR PROVEEDORES PERMITIDOS (China)
      if (user?.ProveedoresPermitidos) {
        try {
          const allowed = JSON.parse(user.ProveedoresPermitidos);
          const list =
            Array.isArray(allowed) && allowed.length > 0 ? allowed : null;
          if (list) {
            enriched = enriched.filter((m) =>
              list.includes(m.NOMBRE_PROVEEDOR),
            );
          }
        } catch (_) {
          // ProveedoresPermitidos inválido: no filtrar
        }
      }

      // ORDENACIÓN
      enriched.sort((a, b) => {
        if (a.NOMBRE_CLIENTE < b.NOMBRE_CLIENTE) return -1;
        if (a.NOMBRE_CLIENTE > b.NOMBRE_CLIENTE) return 1;

        const fechaA = a.FECHA_PREVISTA ? a.FECHA_PREVISTA.getTime() : 0;
        const fechaB = b.FECHA_PREVISTA ? b.FECHA_PREVISTA.getTime() : 0;
        return fechaA - fechaB;
      });

      setMuestras(enriched);
    } catch (err) {
      console.error("Error loading data:", err);
    }
  };

  // SCROLL INFINITO
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setPage((prev) => prev + 1);
        }
      },
      { root: containerRef.current, threshold: 0.2 },
    );

    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, []);

  // FILTRADO COMPLETO

  const normalize = (value) => {
    if (!value) return "";
    return value
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };

  const filteredAll = muestras.filter((m) => {
    const search = normalize(searchTerm);

    const searchableFields = [
      m.MUESTRA,
      m.NOMBRE_CLIENTE,
      m.NombreCliente,
      m.NOMBRE_PROVEEDOR,
      m.DISENADOR,
      m.ESTADO_NOMBRE,
      m.TEMPORADA,
    ];

    const matchesSearch =
      !search ||
      searchableFields.some((field) => normalize(field).includes(search));

    const selTemp = selectedTemporadas || [];
    const selDesigners = selectedDesigners || [];
    const selMarcas = selectedMarcas || [];
    const selEstado = selectedEstado || [];
    const selTallas = selectedTallas || [];
    const selColores = selectedColores || [];
    const selProveedores = selectedProveedores || [];
    return (
      matchesSearch &&
      (selTemp.length === 0 || selTemp.includes(m.TEMPORADA)) &&
      (selDesigners.length === 0 || selDesigners.includes(m.DISENADOR)) &&
      (selMarcas.length === 0 || selMarcas.includes(m.NOMBRE_CLIENTE)) &&
      (selMarcas.length === 0 || selMarcas.includes(m.NombreCliente)) &&
      (selEstado.length === 0 || selEstado.includes(m.ESTADO_NOMBRE)) &&
      (selTallas.length === 0 || selTallas.includes(m.TALLA_NOMBRE)) &&
      (selColores.length === 0 || selColores.includes(m.COLOR_PANTONE)) &&
      (selProveedores.length === 0 ||
        selProveedores.includes(m.NOMBRE_PROVEEDOR)) &&
      (!showPendingArrival ||
        !m.FECHA_RECEPCION ||
        new Date(m.FECHA_RECEPCION) > new Date())
    );
  });

  // PAGINACIÓN DESPUÉS DE FILTRAR
  const filtered = filteredAll.slice(0, page * itemsPerPage);

  // AGRUPACIÓN
  const grouped = filtered.reduce((acc, m) => {
    if (!acc[m.TEMPORADA]) acc[m.TEMPORADA] = {};
    if (!acc[m.TEMPORADA][m.NOMBRE_CLIENTE])
      acc[m.TEMPORADA][m.NOMBRE_CLIENTE] = [];

    acc[m.TEMPORADA][m.NOMBRE_CLIENTE].push(m);
    return acc;
  }, {});

  // Selección
  const handleSelectMuestra = async (m) => {
    try {
      // 1. Cargar cabecera de la muestra
      const muestraData = await getMuestraById(m.id);

      // 2. Cargar todas las líneas de escandallo
      const escData = await getEscandallosByMuestraId(m.id);

      // 3. Para cada línea, cargar SUBGRUPOS según el grupo
      const escandallosFinal = [];

      for (const esc of escData) {
        let subgrupos = [];

        if (esc.ESCANDALLO_GRUPOS) {
          try {
            const res = await getEscandalloSubgruposMuestras(
              esc.ESCANDALLO_GRUPOS,
            );

            subgrupos = res.map((s) => ({
              ID_SUBGRUPO: s.ID_SUBGRUPO,
              SUBGRUPO: s.SUBGRUPO,
            }));
          } catch (err) {
            console.error("Error loading subgroups:", err);
          }
        }

        escandallosFinal.push({
          Escandallo_Id:
            esc.Escandallo_Id ??
            esc.ID_ESCANDALLO ??
            esc.Id_Escandallo ??
            esc.id_escandallo ??
            null,

          ESCANDALLO_GRUPOS: esc.ESCANDALLO_GRUPOS || "",
          ESCANDALLO_SUBGRUPO: esc.ESCANDALLO_SUBGRUPO || "",
          PROVEEDOR_ESCANDALLO: esc.Proveedor || "",
          UN: esc.Un || "",
          COSTE: esc.Coste || "",
          SUBGRUPOS_LIST: subgrupos,
        });
      }

      // 4. Pasamos la data del drawer
      setSelectedMuestra({
        ...muestraData,
        NombreCliente: muestraData.NombreCliente || "Desconocido",
        FECHA_PREVISTA: parseMuestraDate(muestraData.FECHA_PREVISTA),
        FECHA_GET_SUPPLIER: parseMuestraDate(muestraData.FECHA_GET_SUPPLIER),
        FECHA_PETICION: parseMuestraDate(muestraData.FECHA_PETICION),
        FECHA_ENVIO: parseMuestraDate(muestraData.FECHA_ENVIO),
        FECHA_RECEPCION: parseMuestraDate(muestraData.FECHA_RECEPCION),
        FECHA_PREVISTA_FABRICA: parseMuestraDate(
          muestraData.FECHA_PREVISTA_FABRICA,
        ),
        // 👇 Escandallos completos con subgrupos incluidos
        ESCANDALLOS: escandallosFinal,
      });

      setOpenDrawer(true);
    } catch (err) {
      console.error("Error loading sample:", err);
    }
  };

  const handleSaveMuestra = async () => {
    await loadData(userData);
    setOpenDrawer(false);
  };

  // China
  const proveedoresPermitidos = (() => {
    if (!userData?.ProveedoresPermitidos) return [];
    try {
      const parsed = JSON.parse(userData.ProveedoresPermitidos);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  })();

  const hasProveedorLimit =
    Array.isArray(proveedoresPermitidos) && proveedoresPermitidos.length > 0;

  const filterInputSx = {
    width: { xs: "100%", sm: 150, md: 162 },
    minWidth: 0,
    "& .MuiInputBase-root": {
      backgroundColor: theme.palette.caja.main,
      borderRadius: 2,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.divider,
    },
    "& .MuiInputLabel-root": { color: theme.palette.text.secondary },
    "& .MuiInputBase-input": { color: theme.palette.text.primary },
  };

  return (
    <Box
      ref={containerRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        boxSizing: "border-box",
        overflowY: "auto",
        pt: 2,
        pr: { xs: 1.5, md: 3 },
        pb: 2,
        ...contentMargin,
      }}
    >
      <Box
        sx={{
          ml: 2,
          mb: 2,
          p: { xs: 1.5, sm: 2 },
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          position: "sticky",
          top: 0,
          zIndex: 9,
          background:
            "linear-gradient(135deg, rgba(0,188,212,0.12) 0%, rgba(103,58,183,0.1) 100%)",
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 2px 12px rgba(0,0,0,0.35)"
              : "0 2px 12px rgba(0,0,0,0.06)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 1.5, md: 2 },
            alignItems: { md: "flex-start" },
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ flexShrink: 0, maxWidth: { md: 300 } }}>
            <Typography
              variant="overline"
              sx={{ opacity: 0.85, letterSpacing: 1, display: "block" }}
            >
              CRM
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              {t("Samples.Samples")}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {t("sidebar.lookbook")}
            </Typography>
          </Box>

          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexWrap: "wrap",
              gap: 1.25,
              alignItems: "center",
              alignContent: "flex-start",
            }}
          >
            <MuestrasExportExcelDialog
              muestras={muestras}
              buttonProps={{ sx: { alignSelf: "center", flexShrink: 0 } }}
            />
            <MuestrasExportPdfDialog
              muestras={muestras}
              buttonProps={{
                size: "small",
                sx: { alignSelf: "center", flexShrink: 0 },
              }}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                px: 1,
                py: 0.5,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                bgcolor: alpha(theme.palette.common.white, 0.5),
                alignSelf: "center",
              }}
            >
              <Checkbox
                size="small"
                checked={showPendingArrival}
                onChange={(e) => setShowPendingArrival(e.target.checked)}
              />
              <Typography
                component="span"
                variant="body2"
                color="text.secondary"
                sx={{ whiteSpace: "nowrap" }}
              >
                Not Arrived
              </Typography>
            </Box>

            <TextField
              label={t("Samples.search")}
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={filterInputSx}
            />

            {!hasProveedorLimit && (
              <FormControl variant="outlined" size="small" sx={filterInputSx}>
                <InputLabel>{t("Samples.Designer")}</InputLabel>
                <Select
                  multiple
                  value={selectedDesigners}
                  onChange={(e) => setSelectedDesigners(e.target.value)}
                  renderValue={(selected) => selected.join(", ")}
                  sx={filterInputSx}
                >
                  {designers.map((designer) => (
                    <MenuItem key={designer} value={designer}>
                      <Checkbox
                        checked={selectedDesigners.includes(designer)}
                      />
                      <ListItemText primary={designer} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {!hasProveedorLimit && (
              <FormControl variant="outlined" size="small" sx={filterInputSx}>
                <InputLabel>{t("Samples.brand")}</InputLabel>
                <Select
                  multiple
                  value={selectedMarcas}
                  onChange={(e) => setSelectedMarcas(e.target.value)}
                  renderValue={(selected) => selected.join(", ")}
                  sx={filterInputSx}
                >
                  {marcas.map((marca) => (
                    <MenuItem key={marca.MARCA} value={marca.MARCA}>
                      <Checkbox
                        checked={selectedMarcas.includes(marca.MARCA)}
                      />
                      <ListItemText primary={marca.MARCA} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            <FormControl variant="outlined" size="small" sx={filterInputSx}>
              <InputLabel>{t("Samples.season")}</InputLabel>
              <Select
                multiple
                value={selectedTemporadas}
                onChange={(e) => setSelectedTemporadas(e.target.value)}
                renderValue={(selected) => selected.join(", ")}
                sx={filterInputSx}
              >
                {temporadasUnicas.map((temp) => (
                  <MenuItem key={temp} value={temp}>
                    <Checkbox checked={selectedTemporadas.includes(temp)} />
                    <ListItemText primary={temp} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={filterInputSx}>
              <InputLabel>{t("Samples.Status")}</InputLabel>
              <Select
                multiple
                value={selectedEstado}
                onChange={(e) => setSelectedEstado(e.target.value)}
                renderValue={(selected) =>
                  selected.map((name) => formatEstadoLabel(name, t)).join(", ")
                }
                sx={filterInputSx}
              >
                {estados.map((estado) => (
                  <MenuItem key={estado.ESTADO} value={estado.ESTADO}>
                    <Checkbox
                      checked={selectedEstado.includes(estado.ESTADO)}
                    />
                    <ListItemText
                      primary={formatEstadoLabel(estado.ESTADO, t)}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={filterInputSx}>
              <InputLabel>{t("Samples.talla")}</InputLabel>
              <Select
                multiple
                value={selectedTallas}
                onChange={(e) => setSelectedTallas(e.target.value)}
                renderValue={(selected) => selected.join(", ")}
                sx={filterInputSx}
              >
                {tallas.map((talla) => (
                  <MenuItem key={talla.TALLA} value={talla.TALLA}>
                    <Checkbox checked={selectedTallas.includes(talla.TALLA)} />
                    <ListItemText primary={talla.TALLA} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={filterInputSx}>
              <InputLabel>{t("Samples.color")}</InputLabel>
              <Select
                multiple
                value={selectedColores}
                onChange={(e) => setSelectedColores(e.target.value)}
                renderValue={(selected) => selected.join(", ")}
                sx={filterInputSx}
              >
                {colores.map((color) => (
                  <MenuItem key={color.PANTONE} value={color.PANTONE}>
                    <Checkbox
                      checked={selectedColores.includes(color.PANTONE)}
                    />
                    <ListItemText primary={color.PANTONE} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={filterInputSx}>
              <InputLabel>{t("Samples.supplier")}</InputLabel>
              <Select
                multiple
                value={selectedProveedores}
                onChange={(e) => setSelectedProveedores(e.target.value)}
                renderValue={(selected) => selected.join(", ")}
                sx={filterInputSx}
              >
                {proveedores
                  .filter((prov) =>
                    proveedoresPermitidos.length === 0
                      ? true
                      : proveedoresPermitidos.includes(prov.N_PROVEEDOR),
                  )
                  .map((prov) => (
                    <MenuItem key={prov.N_PROVEEDOR} value={prov.N_PROVEEDOR}>
                      <Checkbox
                        checked={selectedProveedores.includes(prov.N_PROVEEDOR)}
                      />
                      <ListItemText primary={prov.N_PROVEEDOR} />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>

      {/* LISTADO AGRUPADO */}
      {Object.keys(grouped).map((temporada) => (
        <Box key={temporada} sx={{ mb: 6, ml: 2 }}>
          {/* TÍTULO DE TEMPORADA */}
          <Typography
            variant="h4"
            sx={{ mb: 3, fontWeight: 900, color: "#444" }}
          >
            {temporada}
          </Typography>

          {Object.keys(grouped[temporada]).map((cliente) => (
            <Box key={cliente} sx={{ mb: 4 }}>
              <Typography
                variant="h5"
                sx={{ mb: 2, fontWeight: 800, color: "#02bbcd" }}
              >
                {cliente}
              </Typography>

              <Grid container spacing={3}>
                {grouped[temporada][cliente].map((muestra) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={muestra.id}>
                    <MuestraCard
                      key={`${muestra.id}-${refreshKey}`}
                      muestra={muestra}
                      onSelect={handleSelectMuestra}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </Box>
      ))}

      {/* LOADER GLOBAL */}
      <div ref={loaderRef} style={{ height: 80 }} />

      {/* DRAWER */}
      {selectedMuestra && (
        /*  <DrawerMuestra */
        <DrawerMuestraV2
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          newMuestra={selectedMuestra}
          setNewMuestra={setSelectedMuestra}
          onSaveMuestra={(muestraId, updatedMuestra) => {
            if (updatedMuestra) {
              setSelectedMuestra((prev) => ({ ...prev, ...updatedMuestra }));
              setMuestras((prev) =>
                prev.map((m) =>
                  m.id === muestraId
                    ? { ...m, ...updatedMuestra, id: muestraId }
                    : m,
                ),
              );
            }
          }}
          onMuestraUpdated={(updated) => {
            setSelectedMuestra((prev) => ({ ...prev, ...updated }));
            setMuestras((prev) =>
              prev.map((m) =>
                m.id === updated.ID_MUESTRA ? { ...m, ...updated } : m,
              ),
            );
          }}
          tiposMuestra={tiposMuestra}
          tiposEstado={estados}
          tiposTallas={tallas}
          tiposColores={colores}
          tiposMarcas={marcas}
          tiposProveedores={proveedores}
          escandalloGrupos={escandalloGrupos}
          escandalloSubgrupos={selectedMuestra?.ESCANDALLO_SUBGRUPOS_LIST || []}
          escandallosIniciales={selectedMuestra.ESCANDALLOS}
          isEditMode={true}
          isFromMuestras={true}
          userHasProveedorLimit={hasProveedorLimit} /* CHINA */
          userCanCreateSample={
            userCanCreateSample
          } /*  añadir muestra al critical path  */
          /** 👇👇 NUEVO **/
          onDeleteMuestra={(id) => {
            setMuestras((prev) => prev.filter((m) => m.id !== id));
          }}
          onRefresh={async () => {
            await loadData(userData);
            setRefreshKey((prev) => prev + 1);
          }}
        />
      )}
    </Box>
  );
};

export default Muestras1;
